import {
    populate
} from 'react-redux-firebase';
import { createSelector } from 'reselect'
import { dockPadEntityMapToList } from '../containers/DockPadFormTemplates';
import { Project } from '../models/Project';
import { createDeepEqualSelector } from './util.selector';

const populatesMap = [{ child: 'users', root: 'users' }];

const populateProject = (state: any) => populate(
    state.firebase,
    'SELECTED_PROJECT',
    populatesMap
)

export const getProjectId = (state:any) => state.projectReducer.selectedProjectId

export const getProject = (state:any) =>  state.projectReducer.selectedProject

export const getReportDays = (state:any) => state.projectReducer.reportDays

export const getProjectWithUsers = createDeepEqualSelector([populateProject, getProjectId], 
    (project:Project, projectId:string)=> {
        if(!project) {
            return null
        }
    
        project['uid'] = projectId;
        return project
})

export const isProjectLoaded = createDeepEqualSelector([getProject], (project) => {
    if(!!project) {
        return true
    }

    return false
})

export const getProjectUsers = createDeepEqualSelector([getProjectWithUsers], project => {
    if (!project || !project.users) return {}
    
    return project.users
})

export const getProjectUsersList = createDeepEqualSelector([getProjectUsers], users => dockPadEntityMapToList(users))



export const getProjectRoles = createDeepEqualSelector([getProject], project => {
    if (!project || !project.roles) return {}

    return project.roles
})

export const getProjectUsersTableFormatted = createSelector([getProjectUsersList, getProjectRoles], (userList, roles) => {
    return userList.map(user => {
        user['role'] = roles[user.uid]
        user['name'] = `${user['first_name']} ${user['last_name']}`
        return user
    })
})

export const getProjectActivities = createSelector([getProject], project => {
    if(!project) return {}
    
    return project.activityLogs
})

export const getScheduleHealth = createSelector([getProject], project => {
    if (!project) return {}

    return project.scheduleHealth
})

export const getProjectName = createSelector([getProject], (project) => {
    if(!project) return ''

    return project.name
})

export const getProjectAddress = createSelector([getProject], (project) => {
    if (!project) return ''

    return project.name
})

export const getProjectLongitude = createSelector([getProject], (project) => {
    if (!project) return null

    return project.longitude
})

export const getProjectLatitude = createSelector([getProject], (project) => {
    if (!project) return null

    return project.latitude
})

export const getProjectSubscription = createSelector([getProject], (project) => {
    if (!project) return null

    return project.subscription
})

export const getDailyUpdateUsers = createSelector([getProject], (project) => {
    if (!project || !project.dailyUpdateUsers) return {}

    return project.dailyUpdateUsers
})

export const getDailyCommitUsers = createSelector([getProject], (project) => {
    if (!project || !project.commitDaily) return {}

    return project.commitDaily
})

export const getInvitedUsers = (state: any) => state.firebase.data.APP_INVITES

export const getCurrentWeather = createSelector([getProject], (project) => {
    if (!project) return null

    return project.currentWeather
})

export const getWeekWeather = createSelector([getProject], (project) => {
    if (!project) return null

    return project.weekWeather
})

export const getRealInviteUsers = (state: any) => dockPadEntityMapToList(
    state.firebase.data.user_invites
)


// WEBPACK FOOTER //
// ./src/selectors/project.selector.ts